import * as ActionTypes from '../components/actions/types';
import { map, uniqBy, filter, indexOf } from 'lodash';

const initialState = [];

function cmsEventVolunteerReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_VOLUNTEER:
      return action.payload;
    case ActionTypes.ADD_CMS_EVENT_VOLUNTEER: {
      const volunteers = map(action.payload, email => ({
        name: '',
        email
      }));
      return uniqBy([...state, ...volunteers], 'email');
    }
    case ActionTypes.REMOVE_CMS_EVENT_VOLUNTEER:
      return filter(
        state,
        volunteer => indexOf(action.payload, volunteer.email) === -1,
      );
    case ActionTypes.CHANGE_VOLUNTEER_ADMISSION_STATUS:
      return map(state, p => (
        (p.email === action.payload.email) ? { ...p, ...action.payload } : p
      ));
    default:
      return state;
  }
}

export default cmsEventVolunteerReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventVolunteer.js